module.exports = __webpack_public_path__ + "operace-usnich-boltcu_8_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-usnich-boltcu_8_after.jpg
// module id = 1225
// module chunks = 0